import { LinkIcon, EmailOutlineIcon } from '@/assets/images';
import { AppIcon } from '@/components';
import { useLanguage } from '@/localization/useLanguage';
import PropTypes from 'prop-types';
import { memo } from 'react';

export const InviteOptionsDrawer = memo(({ viewModel }) => {
   const { t } = useLanguage();
   const { onOpenShareStep, onOpenEmailStep, isLoading } = viewModel;

   return (
      <div className="invite-options-drawer invite-screen--options ct-flex ct-fcol ct-gap28">
         <div className="invite-options-header ct-flex ct-fcol ct-aiCenter ct-gap8">
            <h3 className="invite-options-title">{t('invite.OPTIONS_TITLE')}</h3>
            <p className="invite-options-subtitle">{t('invite.OPTIONS_SUBTITLE')}</p>
         </div>

         <button
            type="button"
            className="invite-action-btn invite-action-btn--primary ct-flex ct-aiCenter ct-jcCenter ct-gap8 ct-cursor"
            onClick={onOpenShareStep}
            disabled={isLoading}
         >
            <AppIcon size="lg" className="invite-action-icon invite-action-icon--primary" icon={<LinkIcon />} />
            <span className="invite-action-title">{t('invite.SHARE_VIA_LINK')}</span>
         </button>

         <div className="invite-or-separator ct-flex ct-aiCenter ct-gap8">
            <span className="invite-or-line" />
            <span className="invite-or-text">{t('invite.OR')}</span>
            <span className="invite-or-line" />
         </div>

         <button
            type="button"
            className="invite-action-btn invite-action-btn--secondary ct-flex ct-aiCenter ct-jcCenter ct-gap8 ct-cursor"
            onClick={onOpenEmailStep}
            disabled={isLoading}
         >
            <AppIcon
               size="lg"
               className="invite-action-icon invite-action-icon--secondary"
               icon={<EmailOutlineIcon />}
            />
            <span className="invite-action-title">{t('invite.SHARE_BY_EMAIL')}</span>
         </button>
      </div>
   );
});

InviteOptionsDrawer.propTypes = {
   viewModel: PropTypes.shape({
      onOpenShareStep: PropTypes.func.isRequired,
      onOpenEmailStep: PropTypes.func.isRequired,
      isLoading: PropTypes.bool,
   }).isRequired,
};
